import React from 'react'
import {
  Location,
  LocationBuilding,
  LocationContainer,
  LocationCredits,
  LocationPickup
} from './Location'

export const SidebarBuildingLocation = ({
  location,
  availableCredits,
  style,
  locationBuildingStyle,
  showInstructions,
  showCredits,
  currentUser,
  redirectOverride,
  showError,
  multipleLocations,
  clearError
}) => (
  <Location style={style}>
    <LocationContainer>
      <LocationBuilding
        currentUser={currentUser}
        showLink
        name={location.deliveryLocationName}
        address={location.address}
        redirectOverride={redirectOverride}
        showError={showError}
        style={locationBuildingStyle}
        multipleLocations={multipleLocations}
        clearError={clearError}
      />
      {showInstructions ? (
        <LocationPickup
          pickupInstruction={location.deliveryPickupInstructions}
        />
      ) : null}
      {showCredits ? (
        <LocationCredits
          creditsEarned={availableCredits}
          style={{ paddingBottom: 0 }}
        />
      ) : null}
    </LocationContainer>
  </Location>
)

export default SidebarBuildingLocation
